import { ICompanyServicePlan } from "modules/company/types";

export const isAgencyWhiteLabellingEnabled = (
  plan: ICompanyServicePlan | null,
): boolean => Boolean(plan?.settings?.company.agencyWhiteLabelling);

export const isWhiteLabellingEnabled = (
  plan: ICompanyServicePlan | null,
): boolean => Boolean(plan?.settings?.company.whiteLabelling);
